import {
  AccountUser,
  CreateRegisteredUser,
  InviteUser,
  RegisteredUser,
  TeamMin,
  UserId,
  UserMin,
  CreateServiceUser,
  ServiceUserApikey,
  ServiceUserApikeyMin,
  UserApikeyId,
} from "../Types";
import {invalidateQueries, q, setQueryData} from "../state";
import jsonApi from "./jsonApi";

export async function listAccountUsers() {
  const res = await jsonApi.get<AccountUser[]>("/users");

  // Pre-populate users
  for (const {user} of res) {
    setQueryData(q.user(user.user_id), {
      user_id: user.user_id,
      name: user.name,
      primary_email: user.primary_email,
      avatar_url: user.avatar_url,
    });
  }

  return res;
}

export async function get(userId: UserId) {
  return await jsonApi.get<UserMin>(`/users/${userId}`);
}

export async function getTeams(userId: UserId) {
  return await jsonApi.get<TeamMin[]>(`/users/${userId}/teams`);
}

export async function createRegistered(user: CreateRegisteredUser) {
  const res = await jsonApi.post<RegisteredUser>("/registered_users", user);
  await invalidateQueries([q.vendorToolkit.gettingStartedChecklist.filter(), q.accountUsers.filter()]);
  return res;
}

export async function createService(user: CreateServiceUser) {
  const res = await jsonApi.post<RegisteredUser>("/service_users", user);
  await invalidateQueries([q.accountUsers.filter()]);
  return res;
}

export async function createServiceApikey(userId: UserId) {
  const res = await jsonApi.post<ServiceUserApikey>(`/service_users/${userId}/apikeys`);
  await invalidateQueries([q.serviceUserApikeys.filter(userId)]);
  return res;
}

export async function listServiceApikeys(userId: UserId) {
  return await jsonApi.get<ServiceUserApikeyMin[]>(`/service_users/${userId}/apikeys`);
}

export async function deleteServiceApikey(userId: UserId, userApikeyId: UserApikeyId) {
  const res = await jsonApi.delete_<"ok">(`/service_users/${userId}/apikeys/${userApikeyId}`);
  await invalidateQueries([q.serviceUserApikeys.filter(userId)]);
  return res;
}

export async function invite(user: InviteUser) {
  const res = await jsonApi.post<RegisteredUser>("/registered_users/invite", user);
  await invalidateQueries([q.vendorToolkit.gettingStartedChecklist.filter(), q.accountUsers.filter()]);
  return res;
}

export async function remove(userId: UserId): Promise<"ok"> {
  const res = await jsonApi.delete_<"ok">(`/users/${userId}`);
  await invalidateQueries([q.accountUsers.filter(), q.owner.filter(), q.resolvedOwner.filter()]);
  return res;
}
